import clickGate from './ClickGate';

class SectionControl {
  constructor() {
    this.changing = false;
    this.pushHistory = true;
    this.curSection = '';
    this.lastSection = '';
    this.sections = new Map();
  }
  init(props) {
    this.curSection = props.firstSection || 'home';
    this.pushHistory = typeof props.pushHistory !== 'undefined' ? props.pushHistory : true;
  }

  async change(sectionId) {
    if (sectionId === this.curSection || this.changing) {
      return;
    }
    this.changing = true;
    if (this.pushHistory) {
      console.log('TODO: history push');
    }
    clickGate.enable();
    this.lastSection = this.curSection;
    this.curSection = sectionId;
    const curSectionObj = this.sections.get(this.curSection);
    const lastSectionObj = this.sections.get(this.lastSection);
    await lastSectionObj.exit();
    curSectionObj.preenter();
    await curSectionObj.enter();
    this.changing = false;
    clickGate.disable();
  }

  registerSection(id, obj) {
    this.sections.set(id, obj);
  }
}

export default new SectionControl();
